// lib/services/tipoEntrada.ts
import { connection } from '@/lib/connection'
import { apiUrl } from '@/lib/config'
import { TipoEntrada } from '@/types/TipoEntrada'

// Usar la función apiUrl que detecta automáticamente si estamos en servidor o cliente
const API_URL = apiUrl('/tipo_entrada');
const API_URL_SECTORES = apiUrl('/sectores');

export async function getTiposEntrada(cookies?: string): Promise<TipoEntrada[]> {
  const data = await connection<any>(API_URL, 'GET', {}, null, cookies);
  return Array.isArray(data.tipo_entrada) ? data.tipo_entrada : [];
}

export async function getSectores(cookies?: string): Promise<TipoEntrada[]> {
  const data = await connection<any>(API_URL_SECTORES, 'GET', {}, null, cookies);
  return Array.isArray(data.tipo_entrada) ? data.tipo_entrada : [];
}

// ⬇️ ahora acepta color
export async function crearTipoEntrada(nombre: string, color: string): Promise<TipoEntrada> {
  const nuevoTipo = { nombre, color };
  const creado = await connection<{ id: string }>(API_URL, 'POST', {}, nuevoTipo);
  return { id: creado.id, nombre, color };
}

export async function eliminarTipoEntrada(id: string) {
  return await connection(`${API_URL}/${id}`, 'DELETE')
}
